import useGeneric from "./useGeneric";

export default function useMensagem() {
    const { GenericCreate } = useGeneric();

    async function sendWarnigForAutoescola(message, usuario_id) {
        try {
            const body = {
                mensagem: message,
                usuario_id: usuario_id
            };
            const response = await GenericCreate('mensagens', 'avisarAutoescola', body);
            if (response.success) {
                return { success: true, data: response.data };
            } else {                
                return { success: false, error: response.error };
            }
        }catch (error) {            
            return { success: false, error: `Erro ao enviar mensagem: ${error.message}` };
        }
    }

    return { sendWarnigForAutoescola };
}
